import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Checkbox } from '@mui/material'
import backdropImage from '../images/two_one_upscaled.webp'
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  getStorage,
} from 'firebase/storage'
import { storage } from '../firebase/firebase' // Import the storage instance
import { toast } from 'react-toastify'
import { BACKEND_URI } from '../config'



// const categories = ["Artillery", "Assortments", "Fountains", "Sparklers", "Black Cats", "Roman Candles", "Cakes", "Small Cakes", "Poppers", "Kid Friendly", "Missiles"];

function Fireworks({ user, setCartItems, onLogout, items, setItems, setEnlargedLinkType, setEnlargedGifLink, setCategoryReturn, fireworkScrollY, setFireworkScrollY, backgroundPosition, setBackgroundPosition }) {
  const navigate = useNavigate()
  const [quantities, setQuantities] = useState({})
  const { category } = useParams()
  const [error, setError] = useState(null)
  const [editingItemId, setEditingItemId] = useState(null) // Tracks which item is being edited
  const [editedItem, setEditedItem] = useState({}) // Stores the edited values
  const [newItem, setNewItem] = useState({})
  const [imgfile, setimgFile] = useState(null)
  const [giffile, setgifFile] = useState(null)
  const [ogimageLink, setogimageLink] = useState(null)
  const [oggifLink, setoggifLink] = useState(null)
  const [isGifVisible, setIsGifVisible] = useState(false)
  // const [enlargedGifLink, setenlargedGifLink] = useState()
  // const [enlargedLinkType, setEnlargedLinkType] = useState('gif')
  const [addingNewItem, setaddingNewItem] = useState(false)
  const [areYouSureDeleteButtonVisible, setareYouSureDeleteButtonVisible] =
    useState(false)

  const handleMouseOver = (e, item) => {
    e.preventDefault();

    if (item.gifUrl) e.target.src = item.gifUrl // Change to GIF
  }

  const handleMouseOut = (e, item) => {
    e.preventDefault();

    e.target.src = item.imageUrl // Change back to image
  }

  const handleClick = (e, item) => {
    e.preventDefault();

    setCategoryReturn(category)

    if (item.gifUrl) {
      setEnlargedLinkType('gif')
      setEnlargedGifLink(item.gifUrl)
      navigate(`/fireworks-enlarged/`)
    }
    else if(item.imageUrl) {
      setEnlargedLinkType('img')
      setEnlargedGifLink(item.imageUrl)
      navigate(`/fireworks-enlarged`)
    }
    // if (isGifVisible) return; // ✅ Prevent re-triggering if already visible

    // // console.log("P")

    // e.target.src = item.imageUrl // Change back to image
    // if (item.gifUrl) {
    //   setenlargedGifLink(item.gifUrl)
    //   setIsGifVisible(true) // Show enlarged GIF
    //   setEnlargedLinkType('gif')
    // } else if (item.imageUrl) {
    //   setenlargedGifLink(item.imageUrl)
    //   setIsGifVisible(true) // Show enlarged GIF
    //   setEnlargedLinkType('img')
    // }
  }

  const handleClose = () => {
    setIsGifVisible(false) // Hide enlarged GIF
  }

  const handleImageFileChange = e => {
    setimgFile(e.target.files[0])
  }

  const handleGifFileChange = e => {
    setgifFile(e.target.files[0])
  }

  const handleFirebaseDelete = async url => {
    if (!url) {
      return
    }
    try {
      const storage = getStorage()

      const filePath = await getFileName(url) // Extract file path

      // Create a reference to the specific file in Firebase Storage
      const fileRef = ref(storage, filePath)

      // Delete the file
      await deleteObject(fileRef)

      // console.log("File deleted successfully.");
    } catch (error) {
      console.error('Error deleting image:', error)
      toast.error('Failed to delete file. Please ensure the URL is correct.')
    }
  }

  const handleFirebaseUpload = async () => {
    try {
      await handleFirebaseUploadImage()
      await handleFirebaseUploadGif()
      toast.success('Files Successfully uploaded')
    } catch (e) {
      toast.error('Error uploading files.')
    }
  }

  const handleFirebaseUploadNewItem = async () => {
    try {
      await handleFirebaseUploadImageNewItem()
      await handleFirebaseUploadGifNewItem()
      toast.success('Files Successfully uploaded')
    } catch (e) {
      toast.error('Error uploading files.')
    }
  }

  const handleFirebaseUploadImageNewItem = async () => {
    if (!imgfile) return

    const storageRef = ref(storage, `uploads/${imgfile.name}`)
    try {
      // Upload file
      const uploadResult = await uploadBytes(storageRef, imgfile)

      // Get download URL
      const url = await getDownloadURL(storageRef)
      setNewItem(prevItem => ({ ...prevItem, imageUrl: url }))
    } catch (error) {
      console.error('Error uploading file:', error)
    }
    // alert("Image uploaded to firebase.")
  }

  const handleFirebaseUploadImage = async () => {
    setogimageLink(editedItem.imageUrl)

    if (!imgfile) return

    const storageRef = ref(storage, `uploads/${imgfile.name}`)
    try {
      // Upload file
      const uploadResult = await uploadBytes(storageRef, imgfile)

      // Get download URL
      const url = await getDownloadURL(storageRef)
      setEditedItem(prevItem => ({ ...prevItem, imageUrl: url }))
    } catch (error) {
      console.error('Error uploading file:', error)
    }
    // alert("Image uploaded to firebase.")
  }

  const handleFirebaseUploadGifNewItem = async () => {
    if (!giffile) return

    const storageRef = ref(storage, `uploads/${giffile.name}`)
    try {
      // Upload file
      const uploadResult = await uploadBytes(storageRef, giffile)

      // Get download URL
      const url = await getDownloadURL(storageRef)
      setNewItem(prevItem => ({ ...prevItem, gifUrl: url }))
    } catch (error) {
      console.error('Error uploading file:', error)
    }
    // alert("Image uploaded to firebase.")
  }

  const handleFirebaseUploadGif = async () => {
    setoggifLink(editedItem.gifUrl)

    if (!giffile) return

    const storageRef = ref(storage, `uploads/${giffile.name}`)
    try {
      // Upload file
      const uploadResult = await uploadBytes(storageRef, giffile)

      // Get download URL
      const url = await getDownloadURL(storageRef)
      setEditedItem(prevItem => ({ ...prevItem, gifUrl: url }))
    } catch (error) {
      console.error('Error uploading file:', error)
    }
    // alert("Image uploaded to firebase.")
  }

  const backgroundStyle = {
    // backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.5) 90%), url(${backdropImage})`,
    backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, 0) 20%), 
                      linear-gradient(to right, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, 0) 20%), 
                      url(${backdropImage})`,
    backgroundSize: '100% auto',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    height: 'auto',
    minHeight: '100vh',
    width: '100%',
    overflow: 'hidden',
    backgroundPositionY: backgroundPosition,
    backgroundColor: 'black',
  }

  const handleEdit = item => {
    setEditingItemId(item._id)
    setEditedItem({
      title: item.title,
      description: item.description,
      price: item.price.replace('$', ''),
      visible: item.visible,
      BOGO: item.BOGO,
      imageUrl: item.imageUrl,
      gifUrl: item.gifUrl,
    })
    setogimageLink(item.imageUrl)
    setoggifLink(item.gifUrl)
  }

  const getFileName = async url => {
    // Extract the file path from the URL
    const decodedUrl = decodeURIComponent(url) // Decode URL-encoded characters
    const pathStartIndex = decodedUrl.indexOf('/o/') + 3 // After '/o/'
    const pathEndIndex = decodedUrl.indexOf('?')

    if (pathStartIndex === -1 || pathEndIndex === -1) {
      throw new Error('Invalid URL format')
    }

    return decodedUrl.substring(pathStartIndex, pathEndIndex) // Extract file path
  }

  const handleSave = async item => {
    if (ogimageLink && editedItem.imageUrl) {
      const ogimagename = await getFileName(ogimageLink)
      const currentimagename = await getFileName(editedItem.imageUrl)

      if (currentimagename !== ogimagename) {
        handleFirebaseDelete(ogimageLink)
      }
    }
    if (oggifLink && editedItem.gifUrl) {
      const oggifname = await getFileName(oggifLink)
      const currentgifname = await getFileName(editedItem.gifUrl)

      if (currentgifname !== oggifname) {
        handleFirebaseDelete(oggifLink)
      }
    }
    setogimageLink(null)
    setoggifLink(null)
    setimgFile(null)
    setgifFile(null)

    try {
      const token = localStorage.getItem('token')
      const response = await fetch(
        `${BACKEND_URI}/api/update-item/${item._id}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(editedItem),
        }
      )

      if (!response.ok) {
        throw new Error('Failed to update item')
      }
      // Update the UI after successful save
      const updatedItem = await response.json()
      setItems(items.map(i => (i._id === item._id ? updatedItem : i)))
      setEditingItemId(null) // Exit edit mode
      setareYouSureDeleteButtonVisible(false)
      toast.success('Successfully updated item!')
    } catch (err) {
      console.error('Error updating item:', err)
      toast.error('Failed to update item. Please try again.')
    }
  }

  const handleCancel = () => {
    if (editedItem.imageUrl !== null && ogimageLink !== editedItem.imageUrl) {
      handleFirebaseDelete(editedItem.imageUrl)
    }
    if (editedItem.gifUrl !== null && oggifLink !== editedItem.gifUrl) {
      handleFirebaseDelete(editedItem.gifUrl)
    }
    setEditingItemId(null) // Exit edit mode without saving
    setogimageLink(null)
    setoggifLink(null)
    setimgFile(null)
    setgifFile(null)
    setareYouSureDeleteButtonVisible(false)
  }

  const handleSaveNewItem = async item => {
    setimgFile(null)
    setgifFile(null)

    let temp_cat = 'Assortments'
    const capitalizedSnippet = category
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    temp_cat = capitalizedSnippet.replace(/ /g, '_') // Replace spaces with underscores

    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${BACKEND_URI}/api/addNewItem/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...item, category: temp_cat }),
      })

      if (!response.ok) {
        throw new Error('Failed to add new item')
      }

      // Update the UI after successful save
      const itemre = await response.json()
      console.log({ ...item, _id: itemre['insertedId'] })
      console.log('b')
      setItems(prevItems => [
        ...prevItems,
        { ...item, _id: itemre['insertedId'] },
      ]) // Add the new item to the list
      setaddingNewItem(false) // Exit add-new-item mode
      setNewItem({})
      toast.success('Successfully added new item!')
    } catch (err) {
      console.error('Error adding new item:', err)
      toast.error(
        'Failed to add new item. Please try again and make sure price is not 0.'
      )
    }
  }

  // const handleCategoryClick = (category) => {
  //     const formattedCategory = category.replace(/ /g, "_"); // Replace spaces with underscores
  //     navigate(`/fireworks/${category.toLowerCase()}`);
  //     const token = localStorage.getItem("token"); // Retrieve the JWT from localStorage
  //     fetch(`${BACKEND_URI}/api/fireworks?category=${(formattedCategory)}`, {
  //         method: "GET", // Optional since GET is the default
  //         headers: {
  //             "Content-Type": "application/json", // Inform server of JSON format
  //             Authorization: `Bearer ${token}`, // Add the token here
  //     },
  //     }).then((response) => {
  //         if (!response.ok) {
  //           onLogout();
  //         }
  //         return response.json();
  //       }).then((data) => setItems(data)).catch((err) => setError(err.message));
  // };

  const handleCancelNewItem = () => {
    if (newItem.imageUrl !== null) {
      handleFirebaseDelete(newItem.imageUrl)
    }
    if (newItem.gifUrl !== null) {
      handleFirebaseDelete(newItem.gifUrl)
    }
    setNewItem({}) // Exit edit mode without saving
    setaddingNewItem(false)
    setimgFile(null)
    setgifFile(null)
  }

  const handleDeleteItem = async item => {
    if (ogimageLink) {
      const ogimagename = await getFileName(ogimageLink)
      handleFirebaseDelete(ogimagename)
    }
    if (editedItem.imageUrl) {
      const currentimagename = await getFileName(editedItem.imageUrl)
      handleFirebaseDelete(currentimagename)
    }

    if (oggifLink) {
      const oggifname = await getFileName(oggifLink)
      handleFirebaseDelete(oggifname)
    }
    if (editedItem.gifUrl) {
      const currentgifname = await getFileName(editedItem.gifUrl)
      handleFirebaseDelete(currentgifname)
    }

    setogimageLink(null)
    setoggifLink(null)
    setimgFile(null)
    setgifFile(null)

    try {
      const token = localStorage.getItem('token')
      const response = await fetch(
        `${BACKEND_URI}/api/delete-item/${item._id}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to delete item')
      }

      console.log('c')
      setItems(prevItems => prevItems.filter(i => i._id !== item._id)) // Remove the deleted item from the state
      setEditingItemId(null) // Exit edit mode
      setareYouSureDeleteButtonVisible(false)
      toast.success('Successfully deleted item!')
    } catch (err) {
      console.error('Error deleting item:', err)
      toast.error('Failed to delete item. Please try again.')
    }
  }

  const handleQuantityChange = (_id, value) => {
    setQuantities(prev => ({
      ...prev,
      [_id]: (value), // Ensure quantity is non-negative
    }))
  }

  const handleAddToCart = async item => {
    const quantity = quantities[item._id] || 1

    if (quantity > 0) {
      setCartItems(prev => {
        const existingItemIndex = prev.findIndex(
          cartItem => cartItem._id === item._id
        )

        const updatedCart = [...prev]
        if (existingItemIndex !== -1) {
          // If item already exists in the cart, update its quantity
          updatedCart[existingItemIndex].quantity = parseFloat(updatedCart[existingItemIndex].quantity) + parseFloat(quantity)
        } else {
          // If item is new, add it to the cart
          updatedCart.push({ ...item, quantity })
        }

        // Save the updated cart to the database
        saveCartToDatabase(updatedCart)
        return updatedCart
      })

      toast.success(`Added ${quantity} of ${item.title} to cart!`)
    } else {
      toast.error('Please select a quantity greater than 0.')
    }

    setQuantities(prev => ({
      ...prev,
      [item._id]: 1, // Reset quantity to 1
    }))
  }

  // Function to save the cart to the database
  const saveCartToDatabase = async cartItems => {
    // Extract category, title, and quantity from cartItems
    const simplifiedCart = cartItems.map(item => ({
      category: item.category,
      title: item.title,
      quantity: item.quantity,
      imageUrl: item.imageUrl,
    }))

    try {
      const token = localStorage.getItem('token') // JWT from localStorage
      const response = await fetch(`${BACKEND_URI}/api/update-cart`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Include JWT
        },
        body: JSON.stringify({ cartItems: simplifiedCart }),
      })

      if (!response.ok) {
        throw new Error('Failed to update cart in database')
      }

      const data = await response.json()
    } catch (err) {
      console.error('Error saving cart to database:', err)
      toast.error('Failed to save cart. Please try again.')
    }
  }

  useEffect(() => {
    window.scrollTo(0,fireworkScrollY)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      let temp_cat = 'Assortments'

      if (!category) {
        navigate(`/fireworks/assortments`)
        return // Prevent further execution
      } else {
        const capitalizedSnippet = category
          .split(' ')
          .map(
            word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(' ')
        temp_cat = capitalizedSnippet.replace(/ /g, '_') // Replace spaces with underscores
      }

      const token = localStorage.getItem('token') // Retrieve the JWT from localStorage

      try {
        const response = await fetch(
          `${BACKEND_URI}/api/fireworks?category=${temp_cat}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (!response.ok) {
          onLogout()
        }
        const data = await response.json()

        const initialQuantities = {}
        data.forEach(item =>{
          initialQuantities[item._id] = 1
        })
        setQuantities(initialQuantities)

        // **ONLY update state if data is different**
        setItems(prevItems => {
          if (JSON.stringify(prevItems) !== JSON.stringify(data)) {
            return data // Update only if the data is different
          }
          return prevItems // Prevents unnecessary re-renders
        })
      } catch (err) {
        setError(err.message)
      }
    }

    fetchData()

  }, [])

  useEffect(() => {
    // Background scroll adjustment logic
    const handleScroll = () => {
      if (window.location.href !== "http://localhost:3000/fireworks-enlarged/") {
        const scrollTop = window.scrollY
        setFireworkScrollY(scrollTop)
        const scrollHeight = document.body.scrollHeight - window.innerHeight
        const scrollRatio = scrollTop / scrollHeight

        // Dynamically adjust background position based on scroll
        setBackgroundPosition(`${scrollRatio * 100}%`)
      }
    }

    // Add scroll listener
    window.addEventListener('scroll', handleScroll)

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (error) {
    return <p>Error: {error}</p>
  }

  return (
    <div style={backgroundStyle}>
      <div style={styles.container}>
        {[...items]
          .sort((a, b) => {
            const priceA = parseFloat(a.price.replace('$', ''))
            const priceB = parseFloat(b.price.replace('$', ''))

            if (priceA !== priceB) {
              return priceB - priceA // Sort by price (low to high)
            } else {
              return a.title.localeCompare(b.title) // If prices are equal, sort alphabetically
            }
          })
          .map(item => (
            <div
              key={item._id}
              style={{
                ...styles.item,
                backgroundColor: item.BOGO ? 'pink' : '#fff',
                display: 'flex', // Flex for side-by-side layout
                flexDirection: 'row', // Row layout
                alignItems: 'center', // Align items in the center
              }}
            >
              {/* Item details */}
              <div style={styles.details}>
                {editingItemId !== item._id && (
                  <h3 style={styles.title}>{item.title}</h3>
                )}
                {editingItemId === item._id ? (
                  <>
                    <div>
                      <label>Title:</label>
                      <textarea
                        value={editedItem.title}
                        onChange={e =>
                          setEditedItem({
                            ...editedItem,
                            title: e.target.value,
                          })
                        }
                        style={styles.textArea}
                      />
                      <label>Description:</label>
                      <textarea
                        value={editedItem.description}
                        onChange={e =>
                          setEditedItem({
                            ...editedItem,
                            description: e.target.value,
                          })
                        }
                        style={styles.textArea}
                      />
                    </div>
                    <div>
                      <label> Price: </label>
                      <input
                        type='number'
                        value={editedItem.price}
                        onChange={e =>
                          setEditedItem({
                            ...editedItem,
                            price: e.target.value,
                          })
                        }
                        style={styles.priceInput}
                      />
                    </div>
                    <div>
                      <label> Visible to customers: </label>
                      <Checkbox
                        checked={editedItem.visible ? true : false}
                        onChange={e =>
                          setEditedItem({
                            ...editedItem,
                            visible: e.target.checked,
                          })
                        }
                      />
                    </div>
                    <div>
                      <label> BOGO: </label>
                      <Checkbox
                        checked={editedItem.BOGO ? true : false}
                        onChange={e =>
                          setEditedItem({
                            ...editedItem,
                            BOGO: e.target.checked,
                          })
                        }
                      />
                    </div>
                    <div>
                      <p>
                        {' '}
                        To change image and gifs, first upload to firebase using
                        choose file, choose gif, and upload tools below. Then
                        hit save to connect the uploaded image to the item.
                      </p>
                      <label>Img Upload: </label>
                      <input type='file' onChange={handleImageFileChange} />
                      <div></div>
                      <label>Gif Upload: </label>
                      <input type='file' onChange={handleGifFileChange} />
                      <div></div>

                      <button onClick={handleFirebaseUpload}>
                        Upload Files to Firebase
                      </button>
                    </div>

                    <div style={styles.adminActions}>
                      <button
                        onClick={() => handleSave(item)}
                        style={styles.saveButton}
                      >
                        Save
                      </button>
                      <button
                        onClick={handleCancel}
                        style={{ ...styles.cancelButton, marginRight: '.5rem' }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={e => {
                          setareYouSureDeleteButtonVisible(true)
                        }}
                        style={
                          areYouSureDeleteButtonVisible
                            ? styles.buttonDisabled
                            : styles.cancelButton
                        }
                      >
                        Delete
                      </button>
                      <div />
                      {areYouSureDeleteButtonVisible && (
                        <div
                          style={{ marginTop: '.5rem', marginBottom: '.5rem' }}
                        >
                          <label>
                            Are you sure you want to delete this item?
                          </label>
                          <div />
                          <button
                            style={styles.saveButton}
                            onClick={e => handleDeleteItem(item)}
                          >
                            Yes
                          </button>
                          <button
                            style={styles.cancelButton}
                            onClick={e =>
                              setareYouSureDeleteButtonVisible(false)
                            }
                          >
                            No
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <p style={styles.description}>{item.description}</p>
                    {user.admin === false && item.BOGO === true && (
                      <div>
                        <span style={{ color: 'red' }}>
                          Buy one get one Free!!
                        </span>
                      </div>
                    )}

                    <span style={styles.price}>{item.price}</span>
                    {user.admin === true && (
                      <div>
                        <div>
                          <span>
                            Item visible to customers:{' '}
                            {item.visible ? 'True' : 'False'}
                          </span>
                        </div>
                        <div>
                          <span>BOGO: {item.BOGO ? 'True' : 'False'}</span>
                        </div>
                        <button
                          onClick={() => handleEdit(item)}
                          style={styles.editButton}
                        >
                          Edit
                        </button>
                      </div>
                    )}
                  </>
                )}

                {!user.admin && <div style={styles.footer}>
                  <div style={styles.actions}>
                    <input
                      type='number'
                      min={1}
                      value={quantities[item._id]}
                      onChange={e =>
                        handleQuantityChange(item._id, e.target.value)
                      }
                      style={styles.quantityInput}
                      onKeyDown={e => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === '-') {
                          e.preventDefault();
                        }
                      }}
                      // onBlur={e => {setQuantities(prev => ({
                      //   ...prev,
                      //   [item._id]: 1, // Always reset to 1 on blur
                      // }));}}
                    />
                    <button
                      style={styles.button}
                      onClick={() => handleAddToCart(item)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>}
              </div>

              {/* Image */}
              {editingItemId !== item._id && (
                <div style={styles.imageContainer}>
                  {/* Image/GIF */}
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    style={styles.image}
                    onMouseOver={e => handleMouseOver(e, item)} // Pass the item
                    onMouseOut={e => handleMouseOut(e, item)} // Pass the item
                    onClick={e => handleClick(e, item)}
                  />

                  {/* Modal/Overlay for Enlarged GIF */}
                  {/* {isGifVisible && (
                    <div style={styles.modalOverlay} onClick={handleClose}>
                      <img
                        src={enlargedGifLink}
                        alt={item.title}
                        style={
                          enlargedLinkType === 'img'
                            ? styles.enlargedImg
                            : styles.enlargedGif
                        }
                      />
                    </div>
                  )} */}
                </div>
              )}
            </div>
          ))}
        {user.admin && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <button
              style={addingNewItem ? styles.buttonDisabled : styles.button}
              onClick={() => setaddingNewItem(!addingNewItem)}
            >
              Add New Item
            </button>
          </div>
        )}
        {addingNewItem && (
          <div style={styles.newitem}>
            <div>
              <label>Title:</label>
              <textarea
                value={newItem.title || ''}
                onChange={e =>
                  setNewItem({ ...newItem, title: e.target.value })
                }
                style={styles.textArea}
              />
              <label>Description:</label>
              <textarea
                value={newItem.description || ''}
                onChange={e =>
                  setNewItem({ ...newItem, description: e.target.value })
                }
                style={styles.textArea}
              />
            </div>
            <div>
              <label> Price: </label>
              <input
                type='number'
                value={newItem.price}
                onChange={e =>
                  setNewItem({ ...newItem, price: e.target.value })
                }
                style={styles.priceInput}
              />
            </div>
            <div>
              <label> Visible to customers: </label>
              <Checkbox
                checked={newItem.visible ? true : false}
                onChange={e =>
                  setNewItem({ ...newItem, visible: e.target.checked })
                }
              />
            </div>
            <div>
              <label> BOGO: </label>
              <Checkbox
                checked={newItem.BOGO ? true : false}
                onChange={e =>
                  setNewItem({ ...newItem, BOGO: e.target.checked })
                }
              />
            </div>
            <div>
              <p>
                {' '}
                To change image and gifs, first upload to firebase using choose
                file, choose gif, and upload tools below. Then hit save to
                connect the uploaded image to the item.
              </p>
              <label>Img Upload: </label>
              <input type='file' onChange={handleImageFileChange} value={undefined} />
              <div />
              <label>Gif Upload: </label>
              <input type='file' onChange={handleGifFileChange} value={undefined}/>
              <div />

              <button onClick={handleFirebaseUploadNewItem}>
                Upload Files to Firebase
              </button>
            </div>

            <div style={styles.adminActions}>
              <button
                onClick={() => handleSaveNewItem(newItem)}
                style={styles.saveButton}
              >
                Save
              </button>
              <button onClick={handleCancelNewItem} style={styles.cancelButton}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
      {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
                <p
                    style={{
                    display: "inline-block", // Fit the content
                    textAlign: "center", // Center-align text
                    padding: "10px", // Add padding
                    color: "white",
                    backgroundColor: "black",
                    borderRadius: "5px", // Optional: round corners
                    }}
                >
                    Contact us at:<br />
                    (832)814-8332<br />
                    sonic.fireworks@yahoo.com
                </p>
            </div> */}
    </div>
  )
}

const styles = {
  adminActions: {
    marginTop: '1rem',
  },
  imageContainer: {
    position: 'relative',
    width: '300px',
    // overflow: "hidden",
    display: 'flex', // Enable flexbox
    justifyContent: 'flex-end', // Align items to the right
    alignItems: 'center', // Optional: Align items vertically (centered)
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark overlay
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // zIndex: 1000,
  },
  enlargedImg: {
    zIndex: 99999,
    width: 'auto',
    height: '60%',
    // boxShadow: "0 0 20px rgba(255, 255, 255, 0.5)",
    // borderRadius: "8px",
    // zIndex: 1100,
  },
  enlargedGif: {
    // zIndex: 99999,
    width: window.innerWidth < 768 ? "100%" : "", // ✅ Changes only on mobile
    // width: "100%",
    // height: "auto",
    height: window.innerWidth < 768 ? "auto" : "", // ✅ Changes only on mobile

    // boxShadow: "0 0 20px rgba(255, 255, 255, 0.5)",
    // borderRadius: "8px",
    // zIndex: 1100,

  //   maxWidth: "90vw",
  // maxHeight: "90vh",
  // width: "auto",
  // height: "auto",
  // objectFit: "contain", // ✅ Ensures entire GIF is visible
  // animation: "none", // ✅ Prevents flickering from repeated CSS animations
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    maxWidth: '600px',
    margin: '0 auto',
    paddingTop: '30px',
  },
  specialCategory: {
    marginTop: '70px',
    marginBottom: '20px',
    textAlign: 'center', // Center align the special category
  },
  categories: {
    display: 'flex',
    flexWrap: 'wrap', // Allows items to wrap onto multiple rows
    gap: '10px', // Space between buttons
    marginBottom: '20px',
    marginTop: '70px',
  },
  categoryButton: {
    color: '#fff',
    minWidth: '100px', // Minimum button width
    flex: '1 1 calc(25% - 10px)', // Responsive sizing: 25% of row minus gap
    textAlign: 'center',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    border: '1px solid #ddd',
    // borderRadius: "8px",
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
  },
  newitem: {
    padding: '1rem',
    border: '1px solid #ddd',
    // borderRadius: "8px",
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
  },
  image: {
    width: '200px',
    height: '200px',
    // borderRadius: "8px",
    objectFit: 'cover',
    // marginRight: "1rem",
    cursor: 'pointer',
    marginLeft: 'auto',
  },
  details: {
    flex: 1,
  },
  title: {
    margin: '0 0 0.5rem 0',
    fontSize: '1.2rem',
    color: '#333',
  },
  description: {
    marginBottom: '1rem',
    fontFamily: "'Trebuchet MS', sans-serif",
    // fontFamily: "'Rajdhani', sans-serif",
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  price: {
    fontWeight: 'bold',
    fontSize: '1rem',
    color: '#007BFF',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  quantityInput: {
    width: '40px',
    padding: '0.3rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    textAlign: 'center',
  },
  button: {
    padding: '0.5rem 1rem',
    backgroundColor: '#51a4ac',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  buttonDisabled: {
    backgroundColor: 'grey',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontSize: '0.9rem',
  },
  details: {
    textAlign: 'left',
  },
  price: {
    fontWeight: 'bold',
  },
  textArea: {
    width: '100%',
    minHeight: '50px',
    marginBottom: '0.5rem',
  },
  priceInput: {
    width: '100%',
    marginBottom: '0.5rem',
  },
  editButton: {
    padding: '0.5rem 1rem',
    marginTop: '0.5rem',
    backgroundColor: '#51a4ac',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#51a4ac',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '0.5rem',
  },
  cancelButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#c53b3a',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
}

export default Fireworks
